todays-deliveries-save-btn
  span.btn-download.btn.btn-success.btn-sm(onClick="{this.onClick}")
    i.feather.icon-save
    | { opts.label }
  script(type="typescript").
    this.mixin('base');
